import { useHistory } from "react-router";
import {
  BarraAzulBody,
  BarraAzulBoton,
  BarraAzulContainer,
  BarraAzulCurva,
} from "./localStyle";

const BarraAzul = ({ title, backBtn, subtitle }) => {
  //#region --------- context ---------------
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const history = useHistory();
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const onClick = () => {
    history.push(`/autocheckin`);
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  //#endregion  -------- useEffect ---------------

  return (
    <BarraAzulContainer>
      {backBtn && (
        <BarraAzulBoton onClick={onClick}>
          <span>Atrás</span>
        </BarraAzulBoton>
      )}
      <BarraAzulBody>
        <span>{title}</span>
        {subtitle && <span className="BarraAzul-subtitle">{subtitle}</span>}
      </BarraAzulBody>
      <BarraAzulCurva />
    </BarraAzulContainer>
  );
};

export default BarraAzul;
